<script setup>
import { ref, watch} from 'vue'
import ToggleSwitch from '@/components/common/ToggleSwitch.vue';

//events raised by component
const emit = defineEmits(["openFilters","updateCategory","toggleMapLabels"])

//reactive field proxies
const toggleDataLabel = ref(false)

//local variables

function setupFilters() {
	emit('openFilters');
}


watch(toggleDataLabel,(value) => {
	emit('toggleMapLabels', value);
});	
</script>

<template>
	<div class="chart-options">
		<div class="chart-options-row">
			<div class="chart-options-row start">
				<div>
					<button @click="setupFilters" class="btn-tertiary"><span class="icon-settings">
						<i class="fa-regular fa-sliders"></i></span>Customize map</button>
				</div>
			</div>
			<div class="map-control">
				<span class="toggle-label">Geography labels</span>
				<ToggleSwitch aria-label="Data label" v-model="toggleDataLabel" />
			</div>
		</div>
	</div>	
</template>

<style scoped>
.chart-options {
	margin: 0 1.25rem 0.25rem 1.25rem;	
}

.chart-options-row {
	display: flex;
	justify-content:space-between;	
	column-gap: var(--spacing-lg);
	height:2.5rem;
}

.chart-options-row.start {
	display: flex;
	justify-content: start;
	column-gap: var(--spacing-lg);
}

.btn-tertiary {
	padding: 0 0.75rem;
	height: 2.5rem;
}

.drop-down {
	padding-left: 0;
}

.icon-settings {
	color: var(--icon-cta-Blue);
	margin-right:.5rem;
}

	.map-control {
		line-height: 48px;
		display: flex;
		align-items: center;
	}
	
	.toggle-label {
		color: var(--brand-color-MedGrey);
		font-family: var(--font-family-Title);
		font-weight: var(--font-weight-Medium);
		font-size: var(--font-size-Base);
		padding-right: .5rem;
		padding-left: 1.5rem;
	}
</style>